import { Component, OnDestroy, OnInit } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { CacheService } from '../../services/cache/cache.service'
import { Router } from '@angular/router'
import { AuthService } from '../../services/auth/auth.service'
import { JsonPipe } from '@angular/common'

@Component({
  selector: 'template-navbar',
  imports: [MatIcon, MatTooltipModule, JsonPipe],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent implements OnInit, OnDestroy {
  constructor(
    private cacheService: CacheService,
    private authService: AuthService,
    private router: Router,
  ) {}

  url: string = ''
  currentDateTime: string = ''
  user: any = {}
  private timer: any

  ngOnInit() {
    this.getInfosUser()
    this.updateDateTime()
    this.timer = setInterval(() => {
      this.updateDateTime()
    }, 1000)
  }

  ngOnDestroy(): void {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  private getInfosUser() {
    this.user = this.authService.getInfosObject()
    if (!this.user || !this.user.id) {
      this.logout()
    }
  }

  private updateDateTime(): void {
    const now = new Date()
    this.currentDateTime = now.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  }

  logout() {
    this.cacheService.clearCache()
    this.router.navigate(['/login'])
  }

  checkAmbient() {
    return this.authService.validURl()
  }
}
